// extracted by mini-css-extract-plugin
export default {"mobileLinks":"footer__mobileLinks__WOZmk","textLink":"footer__textLink__Md3Fw","app":"footer__app__W8mKl"};